// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

customerSelectorToolbarStyles.wrapper = {
    css: css`
        display: flex;
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 10px;
        column-gap: 10px;

        ${xScreen("lte", "xs")} {
            flex-wrap: wrap;
            gap: 10px;
        }
    `,
};

customerSelectorToolbarStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex-basis: 50%;
            ${xScreen("lt", "xs")} {
                flex-basis: 100%;
            }
        `,
    },
};

customerSelectorToolbarStyles.searchButton = {
    variant: "primary",
    css: css`
        margin-left: auto;
        flex-grow: 1;
    `,
};
